

















































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import HeadBack from '@/views/competition/components/HeadBack.vue'
import { getLiveStreamingStatus, enableOrDisableLiveStreamingStatus,enableOrDisableGiftStatus,updateVotesAndHots } from '@/api/index'
import { getTitleList, enableOrDisableCompetition,deleteCompetition,getSmallProgramList,deleteSmallProgram } from '@/api/competition'
import { UserModule } from '@/store/modules/user'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import Empty from '@/components/Empty/index.vue'

@Component({
  name: 'titleManage',
  components: {
    HeadLable,
    InputAutoComplete,
    Empty,
  },
})
export default class extends Vue {
  private input: any = ''
  private counts: number = 0
  private title = '赛事管理';
  private page: number = 1
  private pageSize: number = 50
  private checkList: string[] = []
  private tableData = []
  private id = ''
  private titleId = ''
  private status = ''
  private liveStreamingStatus = ''
  private gift = ''
  private hots = ''
  private votes = ''
  private isSearch: boolean = false
  private options =  []
  private classData: any = {
    title: '修改免费投票次数和增加的热度',
    dialogVisible: false,
    categoryId: '',
    votes: '',
    hots: ''
  }

   // 判断是否有权限
   private hasPermission(): boolean {
    const roles = UserModule.username || [];
    if (roles.includes('admin')) return true;
    return false;
  }

   // 关闭弹窗
   private handleClose(st: string) {
    console.log(this.$refs.classData, 'this.$refs.classData')
    this.classData.dialogVisible = false
    //对该表单项进行重置，将其值重置为初始值并移除校验结果
    this.$refs.classData.resetFields()
  }

  created() {
    if (this.$route.query.titleId) {
      this.titleId = this.$route.query.titleId
    }
    this.init()
  }

  initProp(val) {
    this.input = val
    this.initFun()
  }

  initFun() {
    this.page = 1
    this.init()
  }

  get userName() {
    return UserModule.username
  }

    // 监听 titleId 的变化
    private handleTitleChange() {
    this.init();
  }

  private async init(isSearch?: boolean) {
    // if (this.options.length === 0){
    //   const pageParams = {
    //     page: this.page,
    //     pageSize: this.pageSize,
    //     type: 0,
    //   }
    //   await getTitleList(pageParams)
    //     .then((res: any) => {
    //       if (String(res.data.code) === '1') {
    //         this.options = res.data && res.data.data && res.data.data.records
    //         if (this.titleId === '') {
    //         this.titleId = res.data.data.records[0].id
    //         }
    //         // this.counts = res.data.data.total
    //       }
    //       // if (!res.data.data.records.length && type === 'search') {
    //       //   this.$message.error('未搜索到相关员工，请核对员工姓名是否正确')
    //       // }
    //     })
    //     .catch((err) => {
    //       this.$message.error('请求出错了：' + err.message)
    //     })
    //   }
      this.isSearch = isSearch
      if (this.isSearch == true) {
      this.page = 1
    }
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        number: this.input ? this.input : undefined,
        type: 1,
        titleId: this.titleId
      }
    await getSmallProgramList(params)
      .then((res: any) => {
        if (String(res.data.code) === '1') {
          this.tableData = res.data && res.data.data && res.data.data.records
          this.counts = res.data.data.total
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  // 添加
  private addEmployeeHandle(st: string, username: string) {
    if (st === 'add') {
      this.$router.push({ path: '/smallProgramManage/add', query: { titleId: this.titleId } })
    } else {
      if (username === 'admin') {
        return
      }
      this.$router.push({ path: '/smallProgramManage/add', query: { id: st, titleId: this.titleId } })
    }
  }

  //状态修改
  private statusHandle(row: any) {
    if (row.username === 'admin') {
      return
    }
    this.id = row.id
    this.status = row.status
    this.type = 0
    this.$confirm('确认调整该赛事的状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      enableOrDisableCompetition({ id: this.id, status: !this.status ? 1 : 0,type: this.type })
        .then((res) => {
          if (String(res.status) === '200') {
            this.$message.success('赛事状态更改成功！')
            this.init()
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  //修改当前赛事的赛事直播开关状态
  private liveStreamingStatusHandle(titleId: string,liveStreamingStatus: string) {
    this.id = titleId
    this.liveStreamingStatus = liveStreamingStatus
    this.$confirm('确认调整当前赛事的赛事直播的状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      enableOrDisableLiveStreamingStatus({ id: this.id, liveStreamingStatus: !this.liveStreamingStatus ? 1 : 0 })
        .then((res) => {
          if (String(res.status) === '200') {
            this.$message.success('当前赛事的赛事直播状态更改成功！')
            this.init()
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

 //修改礼物开关状态
 private giftStatusHandle(titleId: String,gift: string) {
    this.id = titleId
    this.gift = gift
    this.$confirm('确认调整礼物的状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      enableOrDisableGiftStatus({ id: this.id, gift: !this.gift ? 1 : 0 })
        .then((res) => {
          if (String(res.status) === '200') {
            this.$message.success('礼物状态更改成功！')
            this.init()
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  //修改免费投票次数和增加的热度
  private votesAndHotsHandle(titleId: string, votes: string, hots: string) {
    this.classData.votes = this.votes
    this.classData.hots = this.hots
    this.classData.dialogVisible = true
  }
// 提交数据
private submitForm() {
  updateVotesAndHots({id: this.titleId, votes: this.classData.votes, hots: this.classData.hots})
  .then((res) => {
          if (String(res.status) === '200') {
            this.$message.success('免费投票次数和增加的热度修改成功！')
            this.init()
            this.classData.dialogVisible = false
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
}

  // 删除
  private deleteHandle(type: string, id: any) {
    if (type === '批量' && id === null) {
      if (this.checkList.length === 0) {
        return this.$message.error('请选择删除对象')
      }
    }
    const params = {
      ids:type === '批量' ? this.checkList.join(',') : id,
      type: 0,
      status: 1
    }
    this.$confirm('确认删除该小程序, 是否继续?', '确定删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteSmallProgram(params)
        .then(res => {
          if (res && res.data && res.data.code === 1) {
            this.$message.success('删除成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }


  // 全部操作
  private handleSelectionChange(val: any) {
    let checkArr: any[] = []
    val.forEach((n: any) => {
      checkArr.push(n.id)
    })
    this.checkList = checkArr
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init()
  }
}
